<template>
  <v-dialog v-model="data.open" scrollable max-width="564px">
    <v-card v-if="data.open">
      <v-card-title class="primary white--text">
        <h3 class="headline"><slot name="title"></slot></h3>
        <v-spacer/>
        <v-btn text small fab @click="data.open = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'InfoDialog',
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
